module.exports = __webpack_public_path__ + "static/media/facial-feedback-success.5215428d.svg";